import noop from 'lodash/noop'

import { fitWhenMapReady } from './fitWhenMapReady'

/**
 * "Nudge" the WebGL DeckOverlay awake without changing the viewport.
 *
 * Same primitive as `fitWhenMapReady(map, noop)` — once the map projection is
 * ready, fire the 1-pixel panBy nudge that gets Google Maps to emit an
 * `idle` event so deck.gl's GoogleMapsOverlay calls forceDraw and renders
 * its layers. This wrapper exists because the `(map, noop)` pattern shows up
 * in six places (master-route both variants, inventory containers,
 * ScheduleStop, etc.) and the intent isn't obvious from the bare call.
 *
 * Returns the same cleanup fn `fitWhenMapReady` does — cancel pending
 * listeners and the post-fit timer on unmount.
 *
 * @param {google.maps.Map | null | undefined} map
 * @param {{ nudgeDelayMs?: number }} [options]
 * @returns {() => void} cleanup
 */
export const nudgeDeckOverlay = (map, options) => fitWhenMapReady(map, noop, options)
